export default __webpack_public_path__ + "static/media/people5full.cd20104f.jpg";